var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bank-account-details"},[_c('BankAccountDetails',{class:{ 'loading-placeholder': _vm.loadingBankAccounts },attrs:{"bankAccount":_vm.bankAccount,"mandate":_vm.mandate,"formDisabled":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }